// src/components/JoinSessionForm.js
import React, { useState } from 'react';
import { useOpenVidu } from '../contexts/OpenViduContext';

export const JoinSessionForm = () => {
  const [sessionId, setSessionId] = useState('');
  const { joinSession, isLoading, isConnected, isMobile, mediaSource, switchMediaSource } = useOpenVidu();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (sessionId.trim()) {
      joinSession(sessionId);
    }
  };

  if (isConnected) return null;

  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '20px' : '40px',
    },
    form: {
      background: 'white',
      padding: isMobile ? '30px 20px' : '40px',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      textAlign: 'center',
      width: isMobile ? '100%' : '400px',
      maxWidth: '90vw',
    },
    title: {
      fontSize: isMobile ? '24px' : '28px',
      marginBottom: '10px',
      color: '#333',
      fontWeight: '700',
    },
    subtitle: {
      fontSize: isMobile ? '14px' : '16px',
      color: '#666',
      marginBottom: '30px',
    },
    input: {
      width: '100%',
      padding: isMobile ? '14px' : '16px',
      margin: '20px 0',
      border: '2px solid #e1e5e9',
      borderRadius: '12px',
      fontSize: isMobile ? '16px' : '18px',
      boxSizing: 'border-box',
      transition: 'border-color 0.3s ease',
    },
    button: {
      width: '100%',
      padding: isMobile ? '14px' : '16px',
      background: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      fontSize: isMobile ? '16px' : '18px',
      cursor: 'pointer',
      transition: 'background 0.3s ease',
      fontWeight: '600',
    },
    mediaSelector: {
      display: 'flex',
      gap: '10px',
      margin: '20px 0',
    },
    mediaButton: {
      flex: 1,
      padding: '12px',
      border: '2px solid #e1e5e9',
      borderRadius: '10px',
      background: 'white',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '14px',
      fontWeight: '600',
    },
    mediaButtonActive: {
      borderColor: '#007bff',
      background: '#007bff',
      color: 'white',
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <h2 style={styles.title}>Join Video Session</h2>
        <p style={styles.subtitle}>
          {isMobile ? 'Mobile App' : 'Desktop App'} - Ready to connect
        </p>
        
        {/* Media Source Selection (Desktop only) */}
        {!isMobile && (
          <div style={styles.mediaSelector}>
            <button
              type="button"
              style={{
                ...styles.mediaButton,
                ...(mediaSource === 'screen' ? styles.mediaButtonActive : {})
              }}
              onClick={() => switchMediaSource('screen')}
            >
              🖥️ Screen Share
            </button>
            <button
              type="button"
              style={{
                ...styles.mediaButton,
                ...(mediaSource === 'camera' ? styles.mediaButtonActive : {})
              }}
              onClick={() => switchMediaSource('camera')}
            >
              📷 Camera
            </button>
          </div>
        )}
        
        <input
          type="text"
          value={sessionId}
          onChange={(e) => setSessionId(e.target.value)}
          placeholder="Enter session ID"
          style={styles.input}
          required
          autoFocus={!isMobile}
        />
        
        <button 
          type="submit" 
          style={styles.button}
          disabled={isLoading}
        >
          {isLoading ? 'Joining...' : 'Join Session'}
        </button>
        
        {isMobile && (
          <p style={{ fontSize: '12px', color: '#666', marginTop: '20px' }}>
            Camera and microphone access will be requested
          </p>
        )}
      </form>
    </div>
  );
};
